// Execute the script after the DOM is fully loaded
document.addEventListener('DOMContentLoaded', () => {

  const stickyHeader = document.getElementById("stickyHeader");
  if (!stickyHeader) return;

  let lastScrollY = window.scrollY;
  let ticking = false;
  let isHiding = false;
  let passedMainContentThreshold = false; // Nueva bandera para rastrear si pasamos el umbral

  // Función para manejar el scroll con animación suave al ocultar
  function handleScroll() {
    const currentScrollY = window.scrollY;
    const mainContent = document.getElementById("MainContent");

    // Solo procedemos si encontramos el MainContent
    if (mainContent) {
      // Obtenemos la distancia exacta desde el borde superior del viewport al MainContent
      const mainRect = mainContent.getBoundingClientRect();
      const mainTopDistance = mainRect.top;

      // Actualizamos si hemos pasado el umbral principal
      if (mainTopDistance <= 52) {
        passedMainContentThreshold = true;
      }

      // PARTE 1: Comportamiento inicial - ocultar cuando MainContent llega a 52px
      if (mainTopDistance <= 52 && !passedMainContentThreshold) {
        // Ocultamos el header solo si es visible y no se está ocultando ya
        if (stickyHeader.classList.contains("show") && !isHiding) {
          isHiding = true;

          // Primero añadimos la clase de ocultamiento para iniciar la animación suave
          stickyHeader.classList.add("hiding");

          // Después de que termine la animación, quitamos la clase show
          setTimeout(() => {
            if (isHiding) { // Verificamos que no se haya cancelado mientras tanto
              stickyHeader.classList.remove("show");
            }
          }, 600); // Tiempo de la animación para sincronizar con el CSS
        }
      }
      // PARTE 2: Comportamiento después de pasar el umbral - como tenías originalmente
      else if (passedMainContentThreshold) {
        // Tu comportamiento original
        if (currentScrollY <= 0) {
          // Si estamos en la parte superior, mostramos el header inmediatamente
          stickyHeader.classList.remove("hiding");
          stickyHeader.classList.add("show");
          isHiding = false;
          passedMainContentThreshold = false; // Reiniciamos el estado
        } else if (currentScrollY > lastScrollY + 5) {
          // Scrolleando hacia abajo: ocultamos muy suavemente
          if (stickyHeader.classList.contains("show") && !isHiding) {
            isHiding = true;

            // Primero añadimos la clase de ocultamiento para iniciar la animación suave
            stickyHeader.classList.add("hiding");

            // Después de que termine la animación, quitamos la clase show
            setTimeout(() => {
              if (isHiding) { // Verificamos que no se haya cancelado mientras tanto
                stickyHeader.classList.remove("show");
              }
            }, 600); // Tiempo de la animación para sincronizar con el CSS
          }
        } else if (currentScrollY < lastScrollY - 5) {
          // Scrolleando hacia arriba: cancelamos cualquier ocultamiento y mostramos
          isHiding = false;
          stickyHeader.classList.remove("hiding");
          stickyHeader.classList.add("show");
        }
      }
      // PARTE 3: Antes de llegar al umbral y no estamos en el tope
      else if (currentScrollY <= 0) {
        // Si estamos en la parte superior, mostramos el header inmediatamente
        isHiding = false;
        stickyHeader.classList.remove("hiding");
        stickyHeader.classList.add("show");
      }
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  // Usamos requestAnimationFrame para mejorar el rendimiento
  window.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleScroll();
      });
      ticking = true;
    }
  }, { passive: true });





    /******************************************************************************
 * ************************************************************************ */


  // Variables globales para almacenar las selecciones
window.selectedWaist = null;
window.selectedInseam = null;

// Función para mostrar/ocultar sublistas (toggles)
window.toggleSublist = function(element) {
    element.classList.toggle('active');

    let subList = element.nextElementSibling;
    if (subList.style.display === "block") {
        subList.style.display = "none";
    } else {
        subList.style.display = "block";
    }
};

// Función para seleccionar variante
window.selectVariant = function() {
    if (window.selectedWaist && window.selectedInseam) {
        const variantValue = `${window.selectedWaist}/${window.selectedInseam}`;
        const variantInput = document.querySelector(`input[type="radio"][value="${variantValue}"]`);

        if (variantInput) {
            variantInput.click();
            variantInput.checked = true;
        }
    }
};

// Función para actualizar opciones de inseam
window.updateInseamOptions = function() {
    const inseamItems = document.querySelectorAll('.sub-list.inseam li');
    inseamItems.forEach(item => {
        const inseamValue = item.getAttribute('data-inseam');
        const variantValue = `${window.selectedWaist}/${inseamValue}`;
        const variantInput = document.querySelector(`input[type="radio"][value="${variantValue}"]`);

        if (variantInput && (variantInput.disabled || variantInput.classList.contains('disabled'))) {
            item.classList.add('disabled');
            item.classList.remove('available');
        } else if (variantInput) {
            item.classList.remove('disabled');
            item.classList.add('available');
        } else {
            item.classList.add('disabled');
            item.classList.remove('available');
        }
    });
};

// Función para seleccionar waist
window.selectWaist = function(element) {
    // Remove 'active' class from all items
    document.querySelectorAll('.sub-list.waist li').forEach(i => i.classList.remove('active'));

    // Add 'active' class to the clicked item
    element.classList.add('active');

    // Capturar el valor del item seleccionado
    const selectedValue = element.textContent.trim();

    // Añadir o actualizar el span con el valor seleccionado
    let waistSelectedSpan = document.getElementById("waist-value-selected");
    if (waistSelectedSpan) {
        waistSelectedSpan.textContent = ':  ' + selectedValue;
    }

    // Guardar el valor seleccionado y actualizar opciones
    window.selectedWaist = element.getAttribute('data-waist');
    window.updateInseamOptions();
    window.selectVariant();
};

// Función para seleccionar inseam
window.selectInseam = function(element) {
    // Verificar si está deshabilitado
    if (element.classList.contains('disabled')) {
        return;
    }

    // Remove 'active' class from all items
    document.querySelectorAll('.sub-list.inseam li').forEach(i => i.classList.remove('active'));

    // Add 'active' class to the clicked item
    element.classList.add('active');

    // Capturar el valor del item seleccionado
    const selectedValue = element.textContent.trim();

    // Añadir o actualizar el span con el valor seleccionado
    let inseamSelectedSpan = document.getElementById("inseam-value-selected");
    if (inseamSelectedSpan) {
        inseamSelectedSpan.textContent = ':  ' + selectedValue;
    }

    // Guardar el valor seleccionado y seleccionar variante
    window.selectedInseam = element.getAttribute('data-inseam');
    window.selectVariant();
};

// Función principal para inicializar todo (puedes llamarla desde la vista rápida)
window.quickViewInit = function() {
    // Reiniciar valores
    window.selectedWaist = null;
    window.selectedInseam = null;

    // Opcional: Si quieres inicializar automáticamente los toggles
    document.querySelectorAll('.toggle').forEach(function(toggle) {
        toggle.onclick = function(event) {
            event.preventDefault();
            window.toggleSublist(this);
        };
    });
};

// OPCIONAL: Inicializar para toda la página
document.addEventListener('DOMContentLoaded', function() {
    window.quickViewInit();
});





/******************************************************************************
 * ************************************************************************ */




/** QUICK AVALIBLE SIZES FUNCTION  *****/

  // Select all product cards
// Función principal para inicializar los hover effects en productos
function initializeProductHoverEffects() {
// Select all product cards (incluyendo los recién cargados)
const productCards = document.querySelectorAll('.grid-product__content');

productCards.forEach(function(card, index) {
  // Verificar si ya fue inicializado para evitar duplicar event listeners
  if (card.dataset.initialized === 'true') {
    return; // Saltamos este card si ya fue inicializado
  }

  // Select the quick shop button and the sizes container within the same card
  const quickButton = card.querySelector('.quick-product__btn');
  const productSizes = card.querySelector('.available-sizes');

  // Initially hide the sizes block
  if (productSizes) {
    productSizes.style.opacity = '0';
    productSizes.style.transition = 'opacity 0.3s ease';
    productSizes.style.display = 'block'; // Force layout visibility
  }

  // Functions to show/hide sizes container
  function showSizes() {
    if (productSizes) {
      productSizes.style.opacity = '1';
      // Ocultar el botón de quick shop cuando se muestran los tamaños
      if (quickButton) {
        quickButton.style.opacity = '0';
        quickButton.style.transition = 'opacity 0.3s ease';
      }
    }
  }

  function hideSizes() {
    if (productSizes) {
      productSizes.style.opacity = '0';
      // Mostrar nuevamente el botón de quick shop cuando se ocultan los tamaños
      if (quickButton) {
        quickButton.style.opacity = '1';
      }
    }
  }

  // Attach events to quickButton and productSizes so the container remains visible when hovered over either
  if (quickButton && productSizes) {
    quickButton.addEventListener('mouseenter', showSizes);
    quickButton.addEventListener('mouseleave', function() {
      setTimeout(function() {
        if (!productSizes.matches(':hover')) {
          hideSizes();
        }
      }, 50);
    });

    productSizes.addEventListener('mouseenter', showSizes);
    productSizes.addEventListener('mouseleave', function() {
      setTimeout(function() {
        if (!quickButton.matches(':hover')) {
          hideSizes();
        }
      }, 50);
    });

    // Marcar este card como inicializado
    card.dataset.initialized = 'true';
  }

  // For each available size option, intercept the click
  if (productSizes) {
    const sizeOptions = productSizes.querySelectorAll('.size-option:not(.disabled)');
    sizeOptions.forEach(function(option) {
      option.addEventListener('click', function(e) {
        e.preventDefault(); // Prevent redirection to the PDP

        // Retrieve the variant_id either from the data attribute or by parsing the href
        const variant = option.getAttribute('data-variant') || (new URL(option.href)).searchParams.get("variant");
        if (!variant) {
          return;
        }

        // AJAX call to add the product to the cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: variant, quantity: 1 })
        })
        .then(response => response.json())
        .then(data => {
          // Add this code to trigger the cart drawer
          document.dispatchEvent(new CustomEvent('cart:open'));

          // Luego actualizamos el contenido del carrito
          if (window.theme && window.theme.cart) {
            // Esta es la forma en que el tema actualiza el contenido del carrito
            document.dispatchEvent(new CustomEvent('cart:build'));
          }

          // Para asegurarnos del estado actualizado del carrito, hacemos una llamada a /cart.js
          fetch('/cart.js')
          .then(response => response.json())
          .then(cartData => {
            const count = cartData.item_count || 0;

            // Intentamos usar el selector definido en el theme, de lo contrario un selector fijo
            let cartBubbleSelector = '.cart-link__bubble';
            if (typeof selectors !== 'undefined' && selectors.cartBubble) {
              cartBubbleSelector = selectors.cartBubble;
            }

            const bubbles = document.querySelectorAll(cartBubbleSelector);

            if (bubbles.length) {
              if (count > 0) {
                bubbles.forEach(b => {
                  b.classList.add('cart-link__bubble--visible');
                });
              } else {
                bubbles.forEach(b => {
                  b.classList.remove('cart-link__bubble--visible');
                });
              }
            }
          })
          .catch(err => {
            console.error("Error fetching cart data:", err);
          });

        })
        .catch(error => console.error('Error adding the product:', error));
      });
    });
  }
});
}

// Inicializar en la carga inicial de la página
document.addEventListener('DOMContentLoaded', function() {
initializeProductHoverEffects();
});

// NUEVA FUNCIÓN: Inicializar también cuando la página esté completamente cargada
window.addEventListener('load', function() {
initializeProductHoverEffects();

// También programamos una inicialización adicional después de un breve retraso
// para asegurar que cualquier componente cargado de forma asíncrona se inicialice correctamente
setTimeout(function() {
  initializeProductHoverEffects();
}, 1000);
});

// NUEVA FUNCIÓN: Escuchar eventos personalizados de Shopify que podrían indicar que se han cargado productos
document.addEventListener('shopify:section:load', function() {
initializeProductHoverEffects();
});

// Configuración del infinite scroll
// jQuery solo se carga en colecciones: sin este chequeo tiraba "$ is not defined" en el resto de páginas. 2026-09-30
if (window.jQuery && $("#AjaxinateContainer").length) {
  // Verificar que existe el enlace de siguiente página antes de inicializar
  if ($(".collectionnextpage").length > 0) {
    $("#AjaxinateContainer").infiniteScroll({
      path: function() {
        var nextLink = document.querySelector('.collectionnextpage');
        if (nextLink) {
          var nextUrl = nextLink.getAttribute('href');
          return nextUrl;
        }
        return null;
      },
      history: false,
      append: ".grid-product",
      status: ".page-load-status",
      debug: true,
      scrollThreshold: 400,
      loadOnScroll: true,
      checkLastPage: true,
      responseBody: 'text',
      domParseResponse: true,
      // Mejorar la detección de última página
      last: function(response, path) {
        // Verificar si la respuesta contiene un enlace de siguiente página
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = response;
        const hasNextPage = tempDiv.querySelector('.collectionnextpage');

        if (!hasNextPage) {
          return true;
        }
        return false;
      }
    });

    // Cuando se solicita más contenido
    $("#AjaxinateContainer").on("request.infiniteScroll", function (event, path, fetchPromise) {
      // Actualizar la paginación con verificación mejorada
      $("#collectionpagination").load(path + " #collectionpagination > *", function() {
        // Verificar si ya no hay más páginas después de la actualización
        const nextPageLink = document.querySelector('.collectionnextpage');
        if (!nextPageLink) {
          $("#AjaxinateContainer").infiniteScroll('destroy');
        }
      });
    });

    // Cuando se añade nuevo contenido después del scroll
    $("#AjaxinateContainer").on("append.infiniteScroll", function (event, response, path, items) {
      // Verificar que realmente se añadieron productos nuevos
      if (items && items.length > 0) {
        // Verificación adicional: contar productos únicos para detectar posibles duplicados
        const allProducts = document.querySelectorAll('.grid-product[data-product-id]');
        const productIds = new Set();

        allProducts.forEach(product => {
          const productId = product.getAttribute('data-product-id');
          if (productId) {
            if (!productIds.has(productId)) {
              productIds.add(productId);
            }
          }
        });

        // Ejecutar las funciones originales si existen
        if (typeof window.reinitializeSwatches === 'function') {
          window.reinitializeSwatches();
        }

        // Aplicar yotpo widgets si están disponibles
        if (typeof yotpoWidgetsContainer !== 'undefined' && typeof yotpoWidgetsContainer.initWidgets === 'function') {
          setTimeout(function() {
            yotpoWidgetsContainer.initWidgets();
          }, 1500);
        }

        // Inicializar nuestros efectos hover en los nuevos productos
        setTimeout(function() {
          initializeProductHoverEffects();
        }, 100);
      }
    });

    // Manejar errores de infinite scroll
    $("#AjaxinateContainer").on("error.infiniteScroll", function (event, error, path) {
      console.error('Infinite scroll error:', error, 'Path:', path);
    });
  }
}

// MEJORA: Expandir el alcance del MutationObserver para incluir más contenedores
// Lista de contenedores a observar
const containersToObserve = [
document.querySelector('#AjaxinateContainer'),
document.querySelector('.grid--collection'), // Común en páginas de colección
document.querySelector('.featured-collection'), // Común en la homepage
document.querySelector('.collection-grid'), // Otro posible contenedor
document.querySelector('.product-recommendations'), // Para recomendaciones de productos
document.querySelector('main') // Como respaldo, observar el contenedor principal
];

// Filtrar los contenedores que existen
const validContainers = containersToObserve.filter(container => container !== null);

// Observador de mutaciones para detectar cambios en el DOM
const observer = new MutationObserver(function(mutations) {
let shouldInitialize = false;

mutations.forEach(function(mutation) {
  if (mutation.addedNodes.length) {
    shouldInitialize = true;
  }
});

if (shouldInitialize) {
  setTimeout(function() {
    initializeProductHoverEffects();
  }, 100);
}
});

// Iniciar observación en todos los contenedores válidos
validContainers.forEach(container => {
observer.observe(container, { childList: true, subtree: true });
});

// NUEVA FUNCIÓN: Programar verificaciones periódicas para productos no inicializados
// Esto es un respaldo para asegurar que todos los productos se inicialicen eventualmente
// incluso si los otros métodos fallan
const periodicCheck = setInterval(function() {
const uninitializedCards = document.querySelectorAll('.grid-product__content:not([data-initialized="true"])');
if (uninitializedCards.length > 0) {
  initializeProductHoverEffects();
}
}, 3000); // Verificar cada 3 segundos

// Detener las verificaciones periódicas después de 30 segundos para no consumir recursos innecesariamente
setTimeout(function() {
clearInterval(periodicCheck);
}, 30000);






});
